import * as React from "react";
import { useOutlet } from "react-router";

interface IOutletOrChildrenProps {
    children: React.ReactNode;
}

export function OutletOrChildren(props: IOutletOrChildrenProps) {
    return useOutlet() || <>{props.children}</>;
}
